<app-n-level-traversal-menu-view
    *ngIf="globalDataService.sideMenuStepOne"
    [traversalPurpose]="TraversalPurpose.SIDE_MENU"
    [firstLevelData]="globalDataService.sideMenuStepOne.attributes"
    [selectedRoute]="selectedPath"
    (leafNodesData)="handleLeafNode($event)"
    [sidenav]="sidenav"
></app-n-level-traversal-menu-view>
